export function NoAdsIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3584_6915)">
        <g clipPath="url(#clip1_3584_6915)">
          <g clipPath="url(#clip2_3584_6915)">
            <path
              d="M10.7303 38.0117C8.53931 38.0117 6.75195 36.282 6.75195 34.1617V11.8617C6.75195 9.74142 8.53931 8.01172 10.7303 8.01172H25.3077C32.1689 8.01172 37.752 13.4147 37.752 20.0545V34.1617C37.752 36.282 35.9646 38.0117 33.7737 38.0117H10.7303Z"
              fill="url(#paint0_linear_3584_6915)"
            />
            <path
              d="M37.7219 18.1974C38.0077 22.0718 36.234 25.5531 33.3566 27.7205V32.7938C33.3566 33.4651 32.8048 34.0117 32.1052 34.0117H12.0034C11.3136 34.0117 10.752 33.4747 10.752 32.7938V13.22C10.752 12.5487 11.3038 12.002 12.0034 12.002H17.7482C20.0146 9.31675 23.5816 7.70559 27.5232 8.06043C32.9526 8.53994 37.3474 12.9035 37.7219 18.1974Z"
              fill="url(#paint1_linear_3584_6915)"
            />
            <path
              d="M27.252 28.0117C32.4987 28.0117 36.752 23.7584 36.752 18.5117C36.752 13.265 32.4987 9.01172 27.252 9.01172C22.0052 9.01172 17.752 13.265 17.752 18.5117C17.752 23.7584 22.0052 28.0117 27.252 28.0117Z"
              fill="white"
            />
            <path
              d="M27.252 6.01172C19.8112 6.01172 13.752 11.8465 13.752 19.0117C13.752 26.1769 19.8112 32.0117 27.252 32.0117C34.6927 32.0117 40.752 26.1769 40.752 19.0117C40.752 11.8465 34.6927 6.01172 27.252 6.01172ZM27.252 10.4971C28.8506 10.4971 30.3309 10.9057 31.6335 11.6184L19.5842 23.2215C18.8441 21.9766 18.4197 20.5417 18.4197 19.0022C18.4197 14.3173 22.3868 10.4971 27.252 10.4971ZM27.252 27.5168C25.6533 27.5168 24.173 27.1082 22.8704 26.3955L34.9197 14.7924C35.6598 16.0373 36.0842 17.4722 36.0842 19.0117C36.0842 23.6967 32.1171 27.5168 27.252 27.5168Z"
              fill="url(#paint2_linear_3584_6915)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3584_6915"
          x1="13.959"
          y1="39.7135"
          x2="28.0671"
          y2="9.3709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E300" />
          <stop offset="0.52" stopColor="#00FC00" stopOpacity="0.89" />
          <stop offset="0.68" stopColor="#17FC00" stopOpacity="0.92" />
          <stop offset="1" stopColor="#8CFC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3584_6915"
          x1="25.8382"
          y1="8.21387"
          x2="21.1725"
          y2="34.2486"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.16" stopColor="#F0FFE3" />
          <stop offset="0.41" stopColor="#DBFFBC" />
          <stop offset="0.64" stopColor="#CCFFA0" />
          <stop offset="0.85" stopColor="#C3FF90" />
          <stop offset="1" stopColor="#C0FF8A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3584_6915"
          x1="13.4756"
          y1="41.9803"
          x2="30.3362"
          y2="11.6564"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#007900" />
          <stop offset="1" stopColor="#00C800" />
        </linearGradient>
        <clipPath id="clip0_3584_6915">
          <rect width="46" height="46" fill="white" />
        </clipPath>
        <clipPath id="clip1_3584_6915">
          <rect width="46" height="46" fill="white" />
        </clipPath>
        <clipPath id="clip2_3584_6915">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
